import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitEnquiry = (payload) => axios.post("/contact.php", payload).then((r) => r.data);
export const listEnquiries = () => api.get("/enquiries").then((r) => r.data);
export const enquiryStats = () => api.get("/enquiries/stats").then((r) => r.data);
export const updateEnquiry = (id, status) => api.patch(`/enquiries/${id}`, { status }).then((r) => r.data);
export const deleteEnquiry = (id) => api.delete(`/enquiries/${id}`).then((r) => r.data);
